import { Typography } from '@mui/material';

import { Flex } from '../Flex';
interface LabeledValueProps {
    label: string;
    value: string | number;
}

const LabeledValue = ({ label, value }: LabeledValueProps) => {
    return (
        <Flex>
            <Typography
                fontWeight="500"
                fontSize="24px"
                lineHeight="34px"
                sx={{ color: 'text.primary', marginRight: '16px' }}
            >
                {label}:
            </Typography>
            <Typography
                fontSize="21px"
                fontWeight="400"
                lineHeight="38px"
                sx={{ color: 'text.300' }}
            >
                {value}
            </Typography>
        </Flex>
    );
};
export default LabeledValue;
